import React, { Component } from "react";
import debounce from "lodash.debounce";
import { connect } from "react-redux";
import _ from "i18n";
import {
  initFilterClient,
  setFilterCollaborators,
  setFilterClientGroup,
  setFilterClient,
  setBudgetTreeSearchWord,
  setFilterYear
} from "actions";
import {
  fetchCollaboratorSuggestions,
  fetchClientGroupSuggestions,
  fetchClientSuggestions,
  fetchBudgetTree
} from "thunks";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";
import styles from "../TimeSheet/TimeSheet.local.scss";
import moment from "moment";
// import { renderYearsArrayBetweenStartDateAndNow } from "Utils";
const years = [moment().year() - 1, moment().year(), moment().year() + 1];

class BudgetSheetFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      yearDivIsVisible: false,
      year: new Date().getFullYear().toString()
    };

    this.loadClientGroupSuggestions = debounce(
      this.loadClientGroupSuggestions,
      1000
    );
    this.loadClientSuggestions = debounce(this.loadClientSuggestions, 1000);
    this.handleSearchInputChange = debounce(this.handleSearchInputChange, 1000);
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideYearSelect.bind(this)
    );
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutsideYearSelect(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ yearDivIsVisible: false });
    }
  }

  handleSearchInputChange(word) {
    this.props.dispatch(setBudgetTreeSearchWord(word));
    this.handleRefreshBudgetSheetTree();
  }

  filterFormIsVisible = isVisible => {
    this.props.filterFormIsVisible(isVisible);
  };

  handleResetFilter = () => {
    // TODO
  };

  handleRefreshBudgetSheetTree = () => {
    this.props.dispatch(fetchBudgetTree());
  };

  handleClientGroupChange = selected => {
    // let groups = selected.map(element => element.value);
    this.props.dispatch(setFilterClientGroup(selected));
    this.props.dispatch(initFilterClient());
    this.handleRefreshBudgetSheetTree();
  };

  handleClientChange = selected => {
    this.props.dispatch(setFilterClient(selected));
    this.handleRefreshBudgetSheetTree();
  };

  handleCollaboratorChange = selected => {
    // let collaborators = selected.map(element => element.value);
    this.props.dispatch(setFilterCollaborators(selected));
    this.handleRefreshBudgetSheetTree();
  };

  handleYearsChange = selected => {
    this.setState({
      year: selected,
      yearDivIsVisible: false
    });
    this.props.dispatch(setFilterYear(selected));
    this.handleRefreshBudgetSheetTree();
  };

  loadClientGroupSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchClientGroupSuggestions(searchWord))
      .then(res => {
        const categories = res.value.data.data.map(t => {
          return { value: t.group, label: t.group, color: "#000000" };
        });
        callback(categories);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadClientSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchClientSuggestions(searchWord))
      .then(res => {
        let clientsList = res.value.data.data.filter(item => item !== null);
        const clients = clientsList.map(t => {
          return { value: t.id, label: t.name, color: "#000000" };
        });
        callback(clients);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadCollaboratorSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchCollaboratorSuggestions(searchWord))
      .then(res => {
        const collaborators = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.name,
            color: "#000000"
          };
        });
        callback(collaborators);
      })
      .catch(er => {
        callback([]);
      });
  };

  renderYearSelect = () => {
    const { yearDivIsVisible, year } = this.state;

    return (
      <div
        ref={this.setWrapperRef.bind(this)}
        className={
          styles.customed_select +
          " " +
          (this.state.yearDivIsVisible ? styles.customed_select_opened : "")
        }
        style={{
          background: "#6d7f92",
          color: "#ffffff"
        }}
      >
        <div className={styles.customed_select_header}>
          <span>{year}</span>
          <div className={styles.actions}>
            <div>
              <span
                className={styles.action}
                onClick={this.handleDisplayYearSelectItems}
              >
                <i
                  className={"icon icon-arrow-down"}
                  style={{
                    color: "#ffffff"
                  }}
                />
              </span>
            </div>
          </div>
        </div>
        {yearDivIsVisible && (
          <div className={styles.customed_select_body}>
            <div className={styles.customed_select_body_options}>
              {years.map((item, index) => (
                <div
                  key={index}
                  className={styles.customed_select_body_option}
                  onClick={() => this.handleYearsChange(item)}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  handleDisplayYearSelectItems = () => {
    this.setState(state => {
      return {
        yearDivIsVisible: !state.yearDivIsVisible
      };
    });
  };

  render() {
    let { budgetSheetFilter, customAddOn, resultCount } = this.props;
    // currentOrganization.startDate && currentOrganization.startDate.date
    //   ? renderYearsArrayBetweenStartDateAndNow(
    //       currentOrganization.startDate.date
    //     )
    //   : renderYearsArrayBetweenStartDateAndNow(new Date());

    let filters = [
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: budgetSheetFilter.clientGroup.selected,
          placeholder: _("clientGroup"),
          handleChange: this.handleClientGroupChange,
          loadSuggestions: this.loadClientGroupSuggestions,
          values: budgetSheetFilter.clientGroup.selected
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: budgetSheetFilter.client.selected,
          key: budgetSheetFilter.clientGroup.selected.length,
          placeholder: _("client"),
          handleChange: this.handleClientChange,
          loadSuggestions: this.loadClientSuggestions,
          values: budgetSheetFilter.client.selected
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: budgetSheetFilter.collaborator.selected,
          placeholder: _("collaborator"),
          handleChange: this.handleCollaboratorChange,
          loadSuggestions: this.loadCollaboratorSuggestions,
          values: budgetSheetFilter.collaborator
        }
      }
    ];

    return (
      <div className="row align-center medium-12">
        <div className="medium-12">
          {this.renderYearSelect()}
          <TTPFilterHorizontalBar
            button
            marginLeft={"10em"}
            label={_("folderNumber")}
            nbResult={resultCount}
            filters={filters}
            customAddOn={customAddOn}
            searchPlaceholder="Search by client name"
            searchInputValue={budgetSheetFilter.searchWord.searchWord}
            handleResetFilter={this.handleResetFilter}
            handleSearchInputChange={this.handleSearchInputChange.bind(this)}
            filterFormIsVisible={this.filterFormIsVisible}
            cssClass="medium-12"
          />
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  budgetSheetFilter: state.budget.filter,
  resultCount: state.budget.tree.resultCount,
  currentOrganization: state.auth.currentOrganization
});

export default connect(mapStateToProps)(BudgetSheetFilter);



// WEBPACK FOOTER //
// ./src/components/BudgetSheetFilter/BudgetSheetFilter.js